import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.password-policy', {
        url: '/password-policy',
        component: 'companyManageApplicationPasswordPolicy',
        resolve: {currentPasswordAuthenticationSettings},
    });
}
/** @ngInject */
function currentPasswordAuthenticationSettings(companyId,application,AuthenticationPoliciesService) {
    return AuthenticationPoliciesService.GetCurrentPasswordAuthenticationSettings(companyId,application.id);
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/authentication-policies/password-policy/password-policy.state.js